'use strict';

export let MainRouteComponent = {

    selector: 'mainRoute',
    template: require('./main-route.html'),
    bindings: {
        utilData: '<'
    },
    controller: class {

        /*@ngInject*/
        constructor($http, MainService, Auth, ArticuloService, $location, ToasterService) {
            Object.assign(this, {$http, MainService, ArticuloService, $location, ToasterService});

            this.slides = [];
            this.listadoCategorias = [];
            this.listadoPromociones = [];
            this.slides = [];

        }

        $onInit() {
            let data = this.utilData;
            this.listadoCategorias = data.categorias;
            this.slides = data.slides;
            this.listadoPromociones = data.ofertas;
            this.listadoArticulosDestacados = data.destacados;
        }


        buscarPorCodigo() {
            if (this.inputBuscarPorCodigo) {
                this.$location.path('/articulo/codigo/' + this.inputBuscarPorCodigo.toUpperCase());
            }
        }

        buscarPorPalabraClave() {
            if (this.inputBuscarPorPalabraClave) {
                let aux = this.inputBuscarPorPalabraClave.replace(/\//g, '%2F');
                this.$location.path('/articulo/palabra-clave/' + aux.toUpperCase());
            }
        }
        
        buscarPorCategoria(){
            this.$location.path('/articulo/categoria/' + this.categoriaSeleccionada.categoria.toUpperCase() + '/' + this.subcategoriaSeleccionada.subcategoria.toUpperCase());
        }
    }
};



// WEBPACK FOOTER //
// ./client/app/main-route/main-route.component.js